import * as signalR from "@microsoft/signalr";
import api from "../api";

export default class SignalRService {
  hubConnection = null
  ConnectionID = null;
  setupSignalR = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl("http://localhost:47101/hub")
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    // hubConnection.value.start()
    //     .catch(err => {
    //         console.error('Failed to connect with hub', err)
    //         return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
    //     });
    return this.hubConnection;
  };
  hubConnection = this.setupSignalR();



  async GetConnectionId(userId) {
    return await api.get(`Common/GetConnectionId/${userId}`);
  }
}
